export const SLOGAN = "The ultimate learning platform";
export const SLOGAN_TITLE = "The Ultimate Learning Platform";

export const TAGLINE = "There's plenty with Quenti";
export const TAGLINE_TITLE = "There's Plenty with Quenti";

export const BODY_COPY_LANDING =
  "Meet Quenti, the new standard for online studying. Powerful, fast, and ads are thrown right out the window. Free forever for students.";
export const BODY_COPY_BASE =
  "Quenti is the modern learning platform designed to let you study anything.";
export const BODY_COPY_SEO = `${BODY_COPY_BASE} Study with flashcards, games and more, all without interruptions.`;
